import rg4js from "raygun4js";
export const { REACT_APP_RAYGUN_KEY: RAYGUN_KEY } = process.env;
export const raygunConfig = () => {
  rg4js("apiKey", RAYGUN_KEY);
  rg4js("enableCrashReporting", true);
};
